'use client'

import CTASection from '@/components/CTASection'
import pricingGrain from '@/images/pricing-grain.png'
import Testimonials from '@/components/TestimonialsSection'
import { ButtonLink } from '@/components/ButtonLink'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import Image from 'next/image'
import LogoGrid from '@/components/LogoGrid'
import { bookDemoLink, signupLink } from '@/config'

export default function Main() {
  return (
    <main className="relative w-full pt-[61.51px] font-sans lg:pt-[73px]">
      <Image
        src={pricingGrain}
        alt="grain"
        className="absolute top-[43px] -z-10 min-h-[621px] w-full"
      />
      <div className="bg-pricing-radial -ro tate-90 absolute top-[-10px] -z-20 h-[783px] w-full opacity-[0.17]" />

      <section
        className={`relative flex w-full flex-col items-center gap-20 px-5 pb-16 pt-20 sm:px-10 xl:px-[100px] xl:pt-[112px]`}
      >
        <div className="flex w-full flex-col items-center gap-4">
          <h4 className="font-robotoMono text-xs font-medium uppercase leading-[100%] tracking-[1.2px] text-[#38BDF9]">
            Pricing
          </h4>
          <h1 className="max-w-[704px] bg-gradient-to-b from-white from-[8.12%] to-[#989EAA] to-[109.09%] !bg-clip-text text-center text-[36px] font-medium leading-[130%] tracking-[-0.64px] text-transparent md:text-5xl xl:text-[64px] xl:!leading-[120%]">
            Simple pricing, for all Snowflake customers
          </h1>

          <p className="w-full text-center text-base !leading-[150%] text-white/90 md:text-lg lg:max-w-[646px] xl:mt-1 xl:text-xl">
            We offer flat rate pricing tailored to your Snowflake usage, at 3%
            of your annual Snowflake spend. You can pay with your existing Snowflake credits, and we always ensure we save you more
            than we charge, guaranteed. Chat with our team to learn more.
          </p>

          <div className="custom-xs:flex-row mt-3 flex flex-col items-center gap-4 xl:mt-6">
            <ButtonLink
              target="_blank"
              href={bookDemoLink}
              variant="primary"
              size="lg"
              className="rounded-xl"
              aria-label="Book a Demo"
            >
              Book a Demo
            </ButtonLink>

            <ButtonLink href={signupLink} size="lg">
              <span className="text-base">Start Free Trial</span>
              <ChevronRightIcon className="-ml-1 h-3 w-3 stroke-2 text-white transition-colors duration-300 group-hover:text-[#38BDF9]" />
            </ButtonLink>
          </div>
        </div>
      </section>

      <LogoGrid />

      <Testimonials />
      <CTASection />
    </main>
  )
}
